export default function PageLoader() {
  return (
    <div className="flex items-center justify-center h-screen">
        <span className="loading loading-dots loading-lg"></span>
    </div>
  );
}
